import {
  IGetNewbuildingJsonQueryResponse200,
  IGetNewbuildingJsonQueryResponse400,
} from '../../repositories/newbuilding-search/v2/get-newbuilding-json-query';
import { isEmpty } from 'ramda';
import { NotFoundError } from '@cian/peperrors/shared';

export function assertNotFoundError(
  response: IGetNewbuildingJsonQueryResponse200 | IGetNewbuildingJsonQueryResponse400,
) {
  if (response.statusCode !== 200) {
    return;
  }

  const jsonQuery = response.response.jsonQuery;
  const isJsonQueryFailed = !jsonQuery || isEmpty(jsonQuery) || 'notFound' in jsonQuery;

  if (isJsonQueryFailed) {
    throw new NotFoundError({
      domain: 'src/shared/api/jsonQuery/assertNotFoundError.ts',
      message: 'JsonQuery empty response',
    });
  }
}
